(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6860],{

/***/ 86860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25617);
/* harmony import */ var _Common_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90429);
/* harmony import */ var react_rating_stars_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11312);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86812);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69226);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(96031);
/* harmony import */ var _Common_Toast__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40804);
/* harmony import */ var _utils_publishReviewToastNotificationText__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(74161);
/* harmony import */ var _utils_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40619);














var CustomerReviewModal = function(param) {
    var product = param.product, open = param.open, onClose = param.onClose, loggedInUserReview = param.loggedInUserReview, onSubmit = param.onSubmit, orderStatusPage = param.orderStatusPage, order_id = param.order_id;
    var handleRatingChange = function handleRatingChange(rating) {
        setReviewState(function(prevState) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, prevState), {
                rating: rating
            });
        });
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var ref15 = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return {
            storeInfo: state.storeReducer.store,
            userData: state.userReducer.data,
            reviewSettings: state.catalogReducer.reviewSettings
        };
    }), storeInfo = ref15.storeInfo, userData = ref15.userData, reviewSettings = ref15.reviewSettings;
    var ref16 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        full_name: (loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.full_name) ? loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.full_name : "",
        review: (loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.review) ? loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.review : "",
        rating: (loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.rating) ? loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.rating : 0
    }), reviewState = ref16[0], setReviewState = ref16[1];
    var ref17 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), DeviceWidth = ref17[0], setDeviceWidth = ref17[1];
    var imageUrl = (product === null || product === void 0 ? void 0 : product.thumbnail_url) || (product === null || product === void 0 ? void 0 : product.image_url);
    var compressedImages = product === null || product === void 0 ? void 0 : (ref = product.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.compressed_images;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setDeviceWidth(_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_5__/* .deviceWidth */ .o);
    }, [
        _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_5__/* .deviceWidth */ .o
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (loggedInUserReview && !orderStatusPage) {
            setReviewState({
                full_name: loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.full_name,
                review: loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.review,
                rating: loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.rating
            });
        }
    }, [
        loggedInUserReview,
        orderStatusPage
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (loggedInUserReview && open) {
            setReviewState({
                full_name: loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.full_name,
                review: loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.review,
                rating: loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.rating
            });
        }
    }, [
        open
    ]);
    var handleChange = function(e) {
        var inputValue = e.target.value;
        if (inputValue && inputValue.trim() || inputValue.length === 0) {
            var maxLength = 1500;
            setReviewState(function(prevState) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, prevState), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, e.target.name, inputValue.slice(0, maxLength)));
            });
        }
    };
    var handleSubmit = function() {
        var payload = {
            store_id: storeInfo.store_id,
            order_id: order_id,
            review_rating: [
                {
                    id: loggedInUserReview ? loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.id : 0,
                    item_id: (product === null || product === void 0 ? void 0 : product.id) || (product === null || product === void 0 ? void 0 : product.item_id),
                    full_name: reviewState.full_name,
                    review: reviewState.review,
                    status: reviewSettings.auto_publish ? 1 : 0,
                    reply: loggedInUserReview ? loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.reply : "",
                    review_seen: false,
                    phone: userData.phone,
                    rating: reviewState.rating
                }, 
            ]
        };
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_11__/* .publishReview */ .zU)(payload, function() {
            (0,_Common_Toast__WEBPACK_IMPORTED_MODULE_6__/* .toastNotifySuccess */ .jh)((0,_utils_publishReviewToastNotificationText__WEBPACK_IMPORTED_MODULE_12__/* .publishReviewToastNotificationText */ .o)(reviewSettings.auto_publish));
            onSubmit && onSubmit();
        }));
        onClose();
    };
    var disableSubmitBtn = function() {
        return !reviewState.review || !reviewState.full_name || !reviewState.rating;
    };
    if (DeviceWidth <= 766) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        visible: open,
        customStyles: {
            height: "100%",
            width: "100%",
            borderRadius: 0,
            padding: 0
        },
        className: "bottom-modal",
        onClose: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().mobileModal),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().header),
                    style: {
                        backgroundColor: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color) ? storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.theme) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.colors) === null || ref5 === void 0 ? void 0 : ref5.primary_color : "#623abe"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            className: "pointer",
                            src: "/assets/images/close-icon.svg",
                            width: "14px",
                            height: "14px",
                            onClick: onClose
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mv0 pl24px",
                            children: "Review Product"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center pt30px",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: (0,_utils_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getImageUrlFromCompressedImages */ .vb)(compressedImages, imageUrl, {
                                        maxImgSize: _utils_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_7__/* .imgSizeEnums.LOW */ .Hp.LOW
                                    }),
                                    width: "54px",
                                    height: "54px"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-column pl16px",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mv0 f14px fw4",
                                            children: (product === null || product === void 0 ? void 0 : product.name) || (product === null || product === void 0 ? void 0 : product.item_name)
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "mv0 f14px pt4px fw4 star-dust",
                                            children: product === null || product === void 0 ? void 0 : (ref6 = product.category) === null || ref6 === void 0 ? void 0 : ref6.name
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-column pt24px",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mv0 pb8px",
                                    children: reviewState.rating ? "Your Rating" : "Rate product"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_rating_stars_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            size: 27,
                                            classNames: (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().gap),
                                            onChange: handleRatingChange,
                                            value: reviewState.rating,
                                            count: 5
                                        }, "stars_".concat(reviewState.rating)),
                                        (loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.rating) && !(loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.review) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "ml20px mv0 bg-lime-green-color pv4px ph8px f12px fw5 white-color br2 ",
                                            children: "Submitted"
                                        }) : null
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-column pt34px",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mv0 pb10px fw5",
                                    children: "Full Name"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    name: "full_name",
                                    value: reviewState.full_name,
                                    onChange: handleChange,
                                    placeholder: "Enter your name"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mv0 pb10px pt6px fw5",
                                    children: "Product review"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                                    name: "review",
                                    value: reviewState.review,
                                    onChange: handleChange,
                                    placeholder: "What did you like or dislike about the product?"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            disabled: disableSubmitBtn(),
                            onClick: handleSubmit,
                            style: {
                                opacity: disableSubmitBtn() ? 0.21 : 1,
                                backgroundColor: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref7 = storeInfo.theme) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.colors) === null || ref8 === void 0 ? void 0 : ref8.primary_color) ? storeInfo === null || storeInfo === void 0 ? void 0 : (ref9 = storeInfo.theme) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.colors) === null || ref10 === void 0 ? void 0 : ref10.primary_color : "#996fd5"
                            },
                            children: "Submit"
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        visible: open,
        height: "auto",
        customStyles: {
            height: "439px",
            borderRadius: "12px",
            width: "528px"
        },
        className: "bottom-modal",
        onClose: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().modal),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    onClick: onClose,
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().crossIcon),
                    src: "https://cdn.dotpe.in/longtail/themes/8073865/tmUxIUUd.webp",
                    height: "18px",
                    width: "18px"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center mb28px",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_7__/* .getImageUrlFromCompressedImages */ .vb)(compressedImages, imageUrl, {
                                maxImgSize: _utils_compressedImagesHelpers__WEBPACK_IMPORTED_MODULE_7__/* .imgSizeEnums.LOW */ .Hp.LOW
                            }),
                            width: "64px",
                            height: "64px"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-column pl16px",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mv0 f14px fw4 pb10px",
                                    children: (product === null || product === void 0 ? void 0 : product.name) || (product === null || product === void 0 ? void 0 : product.item_name)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_rating_stars_component__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            size: 24,
                                            classNames: (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().gap),
                                            onChange: handleRatingChange,
                                            value: reviewState.rating,
                                            count: 5
                                        }, "stars_".concat(reviewState.rating)),
                                        (loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.rating) && !(loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.review) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "ml12px mv0 bg-lime-green-color pv4px ph8px f12px fw5 white-color br2 ",
                                            children: "Submitted"
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-column",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mv0 pb10px 333333DE fw5 f14px",
                            children: "Full Name"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                            name: "full_name",
                            value: reviewState.full_name,
                            onChange: handleChange,
                            placeholder: "Enter your name"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-column pt24px",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mv0 pb10px 333333DE fw5 f14px",
                            children: "Product review"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                            name: "review",
                            value: reviewState.review,
                            onChange: handleChange,
                            placeholder: "What did you like or dislike about the product?"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().btnContainer),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        disabled: disableSubmitBtn(),
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().submitBtn),
                        onClick: handleSubmit,
                        style: {
                            opacity: disableSubmitBtn() ? 0.21 : 1,
                            backgroundColor: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref11 = storeInfo.theme) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.colors) === null || ref12 === void 0 ? void 0 : ref12.primary_color) ? storeInfo === null || storeInfo === void 0 ? void 0 : (ref13 = storeInfo.theme) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.colors) === null || ref14 === void 0 ? void 0 : ref14.primary_color : "#996fd5"
                        },
                        children: "Submit"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomerReviewModal);


/***/ }),

/***/ 40619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hp": function() { return /* binding */ imgSizeEnums; },
/* harmony export */   "N7": function() { return /* binding */ getMaxImgSizeForComponent; },
/* harmony export */   "VW": function() { return /* binding */ getSrcSetFromCompressedImages; },
/* harmony export */   "Xx": function() { return /* binding */ componentTypeEnums; },
/* harmony export */   "vb": function() { return /* binding */ getImageUrlFromCompressedImages; }
/* harmony export */ });
var componentTypeEnums = {
    CARD: 1,
    ITEM_THUMBNAIL: 2
};
var imgSizeEnums = {
    LOW: 1,
    MID: 2,
    HIGH: 3
};
// the srcset is creating a few problems where device pixel ratio is high (loading a lower resolution image)
// consider using getImageUrlFromCompressedImages for any such cases
function getSrcSetFromCompressedImages() {
    var compressedImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mainImage = arguments.length > 1 ? arguments[1] : void 0, extraFields = arguments.length > 2 ? arguments[2] : void 0;
    var parsedCompressedImages = parseCompressedImageObj(compressedImages || {});
    return prepareSrcSet(parsedCompressedImages, mainImage, (extraFields === null || extraFields === void 0 ? void 0 : extraFields.maxImgSize) || imgSizeEnums.HIGH, (extraFields === null || extraFields === void 0 ? void 0 : extraFields.minImgSize) || imgSizeEnums.LOW);
}
function getImageUrlFromCompressedImages() {
    var compressedImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mainImage = arguments.length > 1 ? arguments[1] : void 0, extraFields = arguments.length > 2 ? arguments[2] : void 0;
    var parsedCompressedImages = parseCompressedImageObj(compressedImages || {});
    var screenWidth =  false ? 0 : window.innerWidth;
    var maxImgSize = (extraFields === null || extraFields === void 0 ? void 0 : extraFields.maxImgSize) || imgSizeEnums.HIGH;
    var urlToReturn = mainImage;
    if (parsedCompressedImages[imgSizeEnums.LOW] && (screenWidth <= 320 || maxImgSize === imgSizeEnums.LOW)) {
        urlToReturn = parsedCompressedImages[imgSizeEnums.LOW];
    } else if (parsedCompressedImages[imgSizeEnums.MID] && (screenWidth > 320 && screenWidth < 768 || maxImgSize === imgSizeEnums.MID)) {
        urlToReturn = parsedCompressedImages[imgSizeEnums.MID];
    } else if (parsedCompressedImages[imgSizeEnums.HIGH]) {
        urlToReturn = parsedCompressedImages[imgSizeEnums.HIGH];
    }
    return urlToReturn;
}
function prepareSrcSet() {
    var imgObj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mainImage = arguments.length > 1 ? arguments[1] : void 0, maxImgSize = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : imgSizeEnums.HIGH, minImgSize = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : imgSizeEnums.LOW;
    var resString = "";
    var dpr =  false ? 0 : window.devicePixelRatio;
    if (minImgSize <= imgSizeEnums.LOW && maxImgSize >= imgSizeEnums.LOW && imgObj[imgSizeEnums.LOW]) {
        resString += "".concat(imgObj[imgSizeEnums.LOW], " ").concat(320 * dpr, "w, ");
    }
    if (minImgSize <= imgSizeEnums.MID && maxImgSize >= imgSizeEnums.MID && imgObj[imgSizeEnums.MID]) {
        resString += "".concat(imgObj[imgSizeEnums.MID], " ").concat(480 * dpr, "w, ");
    }
    if (minImgSize <= imgSizeEnums.HIGH && maxImgSize >= imgSizeEnums.HIGH && imgObj[imgSizeEnums.HIGH]) {
        resString += "".concat(imgObj[imgSizeEnums.HIGH], " ").concat(768 * dpr, "w, ");
    }
    if (!maxImgSize || !resString) {
        resString += "".concat(mainImage);
    }
    return resString;
}
// returns Object with image urls corresponding to low medium and high which is Represented by 1,2,3
function parseCompressedImageObj() {
    var compressedImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var res = {};
    var keys = Object.keys(compressedImages) // keys are strings where numbers are separated by *. Eg. "200*200"
    ;
    // sorting keys (eg. key=200*200) to handle the case when we get jumbled order of image sizes.
    keys.sort(function(a, b) {
        var first = parseInt(a.split("*")[0]);
        var second = parseInt(b.split("*")[0]);
        return first - second;
    });
    if (keys.length >= 1) {
        res[imgSizeEnums.LOW] = compressedImages[keys[0]];
    }
    if (keys.length >= 2) {
        res[imgSizeEnums.MID] = compressedImages[keys[1]];
    }
    if (keys.length >= 3) {
        res[imgSizeEnums.HIGH] = compressedImages[keys[2]];
    }
    return res;
}
function getMaxImgSizeForComponent(componentType) {
    if (componentType === componentTypeEnums.CARD) {
        return imgSizeEnums.MID;
    } else if (componentType === componentTypeEnums.ITEM_THUMBNAIL) {
        return imgSizeEnums.LOW;
    }
    return imgSizeEnums.MID;
}


/***/ }),

/***/ 74161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ publishReviewToastNotificationText; }
/* harmony export */ });
function publishReviewToastNotificationText(autoPublishFlag) {
    return autoPublishFlag ? "Thank you for submitting review." : "Thank you for submitting review. It is currently under process.";
}


/***/ }),

/***/ 69226:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"CustomerReviewModal_modal__KYzk8","gap":"CustomerReviewModal_gap__xeXG_","crossIcon":"CustomerReviewModal_crossIcon__W4th3","btnContainer":"CustomerReviewModal_btnContainer__0ITTN","cancelBtn":"CustomerReviewModal_cancelBtn__6J7Hi","submitBtn":"CustomerReviewModal_submitBtn__n4GQY","mobileModal":"CustomerReviewModal_mobileModal__P35iH","header":"CustomerReviewModal_header__LPSb_"};

/***/ })

}]);